import { AnalysisCalculationLevel } from '@api-types/enums/analysis-calculation-level.enum';
import { AnalysisMissingValueStrategy } from '@api-types/enums/analysis-missing-value-strategy.enum';
import { AnalysisType } from '@api-types/enums/analysis-type.enum';
import { TranslateService } from '@ngx-translate/core';

export type SummaryRow = { label: string; value: string };

export type AnalysisConfigurationSummary = {
  general: SummaryRow[];
  timeseries: SummaryRow[];
  missingValueNoteKey: string | undefined;
  hierarchy: SummaryRow[];
  measures: SummaryRow[];
  consensusEvaluated: boolean;
};

export const SUMMARY_EMPTY_VALUE = '—';
export const SUMMARY_LIST_SEPARATOR = ', ';
export const SUMMARY_HIERARCHY_SEPARATOR = ' → ';

export const SUMMARY_ANALYSIS_TYPE_KEYS: Record<AnalysisType, string> = {
  [AnalysisType.ROLLING]: 'ANALYSIS.CREATE_CONFIGURATION.TRACK_ROLLING',
  [AnalysisType.SINGLE_PERIOD]: 'ANALYSIS.CREATE_CONFIGURATION.TRACK_SINGLE',
};

export const SUMMARY_CALCULATION_LEVEL_KEYS: Record<
  AnalysisCalculationLevel,
  string
> = {
  [AnalysisCalculationLevel.LOWEST]: 'ANALYSIS.CALCULATION_LEVEL.LOWEST',
  [AnalysisCalculationLevel.HIGHEST]: 'ANALYSIS.CALCULATION_LEVEL.HIGHEST',
};

export const SUMMARY_MISSING_VALUE_NOTE_KEYS: Record<
  AnalysisMissingValueStrategy,
  string
> = {
  [AnalysisMissingValueStrategy.NEAREST_EARLIER]:
    'ANALYSIS.DETAILS.MISSING_VALUES_NEAREST',
  [AnalysisMissingValueStrategy.SKIP_MONTH]:
    'ANALYSIS.DETAILS.MISSING_VALUES_SKIP',
};

export const formatSummaryMonths = (
  translate: TranslateService,
  count: number,
): string => {
  const unit = translate.instant(
    count === 1
      ? 'RESULT_OVERVIEW.HORIZON.MONTH'
      : 'RESULT_OVERVIEW.HORIZON.MONTHS',
  );
  return `${count} ${unit}`;
};
